import { cookieStorage, localStorage } from '@muse-web/storages'

import { SESSION_ID_KEY } from '../constants/cookieKeys'
import {
    MEMBER_EXPERIMENT_FIRST_SESSION_ID_KEY,
    SESSION_EVENT_SENT_ID_KEY,
} from '../constants/storageKeys'

import { sendEvent } from './sendEvent'

/**
 * True only while the very first session of this member-experiment cohort is still running.
 * `updateMemberFirstSessionId` records that session id verbatim, so this is a string compare
 * against the raw cookie.
 */
export const isFirstSession = (sessionId?: string): boolean =>
    Boolean(sessionId) && localStorage.get(MEMBER_EXPERIMENT_FIRST_SESSION_ID_KEY) === sessionId

/**
 * Takes the once-per-session right to report the session start, so a soft navigation or a tab
 * coming back into view does not re-report a session already counted.
 */
export const claimSessionEvent = (sessionId: string): boolean => {
    if (localStorage.get(SESSION_EVENT_SENT_ID_KEY) === sessionId) {
        return false
    }

    localStorage.set(SESSION_EVENT_SENT_ID_KEY, sessionId)

    return true
}

export const sendSessionStartEvent = () => {
    const sessionId = cookieStorage.get(SESSION_ID_KEY)

    if (!sessionId || !claimSessionEvent(sessionId)) {
        return
    }

    sendEvent({ name: isFirstSession(sessionId) ? 'First Session' : 'Session Start', payload: {} })
}
